<template>
    <div class="container-fluid">
        <div class="row my-4">
            <button
                @click.prevent="deleteQuestionnaire"
                type="button"
                class="btn bg-utel-v2-secondary p-2 px-3 rounded-pill text-primary d-inline-block"
                style="width: fit-content"
                alt="Eliminar Cuestionario"
                title="Eliminar cuestionario"
            >
                <i class="fa-regular fa-trash-can"></i>
                Eliminar cuestionario
            </button>
        </div>
        <div class="row mt-4">
            <h4 class="questionnaire-title">Configuración del cuestionario</h4>
            <p>Detalles de la configuración (si es necesario)</p>
        </div>

        <div class="row mt-4">
            <label for="questionnaireGradeInput" class="questionnaire-label"><strong>Nota de aprobación (%)</strong></label>
            <input v-model="questionnaire.aprobacion" type="number" id="questionnaireGradeInput" class="form-control sin-borde rounded-8">
        </div>

        <div class="row mt-4">
            <label for="questionnaireRepsInput" class="questionnaire-label"><strong>Retoma (# repeticiones)</strong></label>
            <input v-model="questionnaire.repeticiones" type="number" id="questionnaireRepsInput" class="form-control sin-borde rounded-8">
        </div>

        <div class="row mt-4">
            <label for="" class="questionnaire-label"><strong>Duración de la lección</strong></label>
            <div class="col-md-4 ps-0">
                <input v-model="questionnaire.duracion" type="number" class="form-control sin-borde rounded-8" value="1">
            </div>
            <div class="col-md-8 pe-0">
                <select v-model="questionnaire.tipoDuracion" class="form-control sin-borde rounded-8">
                    <option value="minutos">Minuto(s)</option>
                    <option value="horas" selected>Hora(s)</option>
                    <option value="dias">Día(s)</option>
                    <option value="semanas">Semana(s)</option>
                </select>
            </div>
        </div>

        <div class="row mt-4">
            <h5>Preguntas</h5>
            <p>Las preguntas son relacionadas a el contenido del curso y permiten validar el conocimiento adquirido</p>

            <draggable v-model="questionnaire.questions" handle=".handle" :animation="200">
                <transition-group>
                    <div class="question-container my-3 d-flex" v-for="(question, index) in questionnaire.questions" :key="question.id">
                        <div class="drag-icon px-2 d-flex align-items-center py-3">
                            <i class="fa fa-grip-vertical handle fa-2x"></i>
                        </div>
                        <div class="d-flex question-content w-100 p-1 justify-content-between align-items-center bg-utel-v2-secondary">
                            <div>
                                <span class="ms-2">
                                    <strong>
                                        <i class="fa fa-file-circle-question"></i>
                                        {{question.name}}
                                    </strong>
                                </span>
                            </div>
                            <div class="d-flex">
                                <button
                                    type="button"
                                    class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                                    alt="Copiar pregunta"
                                    title="Copiar pregunta"
                                    @click="cloneQuestion(question)"
                                >
                                    <i class="fa-regular fa-copy"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                                    alt="Editar pregunta"
                                    title="Editar pregunta"
                                    @click="editQuestion(question)"
                                >
                                    <i class="fa-regular fa-pen-to-square"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary"
                                    alt="Eliminar pregunta"
                                    title="Eliminar pregunta"
                                    @click="deleteQuestion(question)"
                                >
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
        </div>
        <div class="row mt-4 bg-utel-v2-secondary rounded-8 px-2 py-3" v-if="activeQuestion">
            <question-component
                @onCancel="resetActiveQuestion"
                @onSave="saveActiveQuestion"
                @onDelete="deleteActiveQuestion"
                :question="activeQuestion"
                :question_number="questionnaire.questions.length + 1"
                :eliminaQuestionAnswer="eliminaQuestionAnswer"
                :editing="editing"
            ></question-component>
        </div>
        <div class="my-3 mt-4 d-flex justify-content-end">
            <button class="btn btn-outline-primary rounded-8" @click="addQuestion">
                <i class="mx-2 fa fa-plus"></i>
                Agregar pregunta
            </button>
        </div>
    </div>
</template>
<script>
    import questionComponent from './NewCourseStep2Question.vue';

    export default {
        props: ['questionnaire', 'editing', 'eliminaPost','eliminaQuizQuestion','eliminaQuestionAnswer','eliminaSection','eliminaItemQuestionnaire'],
        components: {
            questionComponent
        },
        data(){
            return {
                activeQuestion: {
                    id: Date.now(),
                    question_type: 'true_or_false',
                    question: '',
                    description: '',
                    advice: '',
                    explanation: '',
                    answers: [],
                    answer: 'Verdadero',
                    name: 'Pregunta 1'
                },
                validating: false,
                isEditing: this.editing || false
            }
        },
        beforeUpdate(){
            if (!this.validating) {
                this.validating = true;
                this.validate();
                this.validating = false;
            }
        },
        mounted(){
            if (this.editing) {
                this.activeQuestion = null;
            }
        },
        methods: {
            addQuestion(){
                this.activeQuestion = {
                    id: Date.now(),
                    question_type: 'true_or_false',
                    question: '',
                    description: '',
                    advice: '',
                    explanation: '',
                    answers: [],
                    answer: 'Verdadero',
                    name: `Pregunta ${this.questionnaire.questions.length + 1}`
                }
            },
            resetActiveQuestion(){
                this.activeQuestion = null;
            },
            saveActiveQuestion(question){
                const savedQuestion = this.questionnaire.questions.find(q => q.id === question.id );
                if (savedQuestion) {
                    this.questionnaire.questions = this.questionnaire.questions.map(q => {
                        if (q.id === question.id) {
                            return question;
                        }

                        return q;
                    });
                }else{
                    this.questionnaire.questions.push(question);
                }
                this.activeQuestion = null;
            },
            deleteActiveQuestion(questionId){
                const questionSaved = this.questionnaire.questions.find(q => q.id === questionId);
                if (questionSaved) {
                    this.addIdsToDelete(questionSaved);
                }

                this.activeQuestion = null;
                if (questionId) {
                    this.questionnaire.questions = this.questionnaire.questions
                                                .filter(question => question.id !== questionId);
                }
            },
            cloneQuestion(question){
                this.activeQuestion = null;
                const cloneQuestion = JSON.parse(JSON.stringify(question));

                setTimeout(() => {
                    this.activeQuestion = {
                        ...cloneQuestion,
                        id: Date.now(),
                        name: `${question.name} - copia`
                    }
                }, 200);
            },
            editQuestion(question){
                this.activeQuestion = null;
                const cloneQuestion = JSON.parse(JSON.stringify(question));
                setTimeout(() => {
                    this.activeQuestion = cloneQuestion;
                }, 200);
            },
            deleteQuestion(question){
                this.addIdsToDelete(question);
                this.questionnaire.questions = this.questionnaire.questions.filter(q => q.id !== question.id);
            },
            addIdsToDelete(question){
                if (!!question.post_id) this.eliminaPost?.push(question.post_id);
                if (!!question.quiz_question_id) this.eliminaQuizQuestion?.push(question.quiz_question_id);
                question.answers.forEach(answer =>{
                    if (!!answer.question_answer_id) {
                        this.eliminaQuestionAnswer?.push(answer.question_answer_id);
                    }
                });
            },
            validate(){
                this.questionnaire.isValid = true;

                ['aprobacion', 'repeticiones', 'duracion','tipoDuracion'].forEach(propertyName => {
                    if (this.questionnaire[propertyName].trim().length < 1) {
                        this.questionnaire.isValid = false;
                    }
                });
            },
            deleteQuestionnaire(){
                if (!!this.questionnaire.post_id) this.eliminaPost?.push(this.questionnaire.post_id);
                if (!!this.questionnaire.section_item_id) {
                    this.eliminaItemQuestionnaire?.push(this.questionnaire.section_item_id);
                }

                this.$emit('onDelete', this.questionnaire);
            }
        }
    }
</script>
<style>
    .drag-icon{
        background-color: #E0E2FF4D;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        cursor: move;
    }

    .question-content{
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
</style>
